module.exports = __webpack_public_path__ + "static/media/dog_death.d742bbc5.mp3";